import get from 'lodash/get'

import {
  fetchCollection
} from './index'

import { pinHistorySchema } from '../schemas'

export const PIN_HISTORIES_REQUEST = 'PIN_HISTORIES_REQUEST'
export const PIN_HISTORIES_SUCCESS = 'PIN_HISTORIES_SUCCESS'
export const PIN_HISTORIES_FAILURE = 'PIN_HISTORIES_FAILURE'

export function fetchHistoriesForPin (url, pinId) {
  return fetchCollection({
    url,
    key: 'pinHistories',
    schema: pinHistorySchema,
    actions: [ PIN_HISTORIES_REQUEST, PIN_HISTORIES_SUCCESS, PIN_HISTORIES_FAILURE ],
    responseInterceptor: response => ({ ...response, pinId })
  })
}

export function loadHistoriesForPin (pinId, nextPage, reload) {
  const firstPageUrl = `/pins/${pinId}/history`

  return (dispatch, getState) => {
    let {
      nextPageUrl = firstPageUrl,
      pageCount = 0
    } = get(getState(), `pagination.historiesByPin.${pinId}`, {})

    if (reload) {
      nextPageUrl = firstPageUrl
    }

    if (pageCount > 0 && !nextPage && !reload) {
      return null
    }

    return dispatch(fetchHistoriesForPin(nextPageUrl, pinId))
  }
}



// WEBPACK FOOTER //
// ./src/actions/histories.js